import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Encryptid } from '../../types/encryptidTypes';

export interface EncryptidsState {
  encryptids: Encryptid[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: EncryptidsState = {
  encryptids: [],
  status: 'idle',
  error: null,
};

export const fetchEncryptids = createAsyncThunk(
  'encryptids/fetchEncryptids',
  async () => {
    // Replace this with actual API call when available
    const response = await new Promise<Encryptid[]>((resolve) => 
      setTimeout(() => resolve([
        { id: '1', name: 'Encryptid 1', type: 'Basic', health: 100, attack: 10, defense: 5, power: 50, aligned: false, position: { x: 0, y: 0 } },
        { id: '2', name: 'Encryptid 2', type: 'Advanced', health: 150, attack: 15, defense: 8, power: 75, aligned: true, position: { x: 10, y: 10 } },
      ]), 1000)
    );
    return response;
  }
);

const encryptidsSlice = createSlice({
  name: 'encryptids',
  initialState,
  reducers: {
    addEncryptid: (state, action: PayloadAction<Encryptid>) => {
      state.encryptids.push(action.payload);
    },
    removeEncryptid: (state, action: PayloadAction<string>) => {
      state.encryptids = state.encryptids.filter(e => e.id !== action.payload);
    },
    updateEncryptid: (state, action: PayloadAction<Partial<Encryptid> & { id: string }>) => {
      const index = state.encryptids.findIndex(e => e.id === action.payload.id);
      if (index !== -1) {
        state.encryptids[index] = { ...state.encryptids[index], ...action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEncryptids.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchEncryptids.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.encryptids = action.payload;
      })
      .addCase(fetchEncryptids.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch encryptids';
      });
  },
});

export const { addEncryptid, removeEncryptid, updateEncryptid } = encryptidsSlice.actions;
export default encryptidsSlice.reducer;